/**
 * Registration translation keys
 */
export const REGISTRATION_FORM_TITLE_TRANSLATION_KEY =
  'registration_form_title';
export const REGISTRATION_GENERAL_INFO_BANNER_TITLE_TRANSLATION_KEY =
  'registration_general_info_banner_title';
export const REGISTRATION_GENERAL_INFO_BANNER_MESSAGE_TRANSLATION_KEY =
  'registration_general_info_banner_message';
export const REGISTRATION_GENERAL_INFO_BANNER_MESSAGE_LINK_TEXT_TRANSLATION_KEY =
  'registration_general_info_banner_message_link_text';
export const REGISTRATION_GENERAL_ERROR_BANNER_TITLE_TRANSLATION_KEY =
  'registration_generic_alert_banner_title';
export const REGISTRATION_GENERAL_ERROR_BANNER_MESSAGE_TRANSLATION_KEY =
  'registration_generic_alert_banner_message';
export const REGISTRATION_CREATE_ACCOUNT_SPINNER_MESSAGE_TRANSLATION_KEY =
  'registration_create_account_spinner_text';

export const REGISTRATION_ACCESS_DENIED_FOR_MANAGER_ACCOUNT_TRANSLATION_KEY =
  'registration_access_denied_for_manager_account';
export const REGISTRATION_INVALID_ZIP_CODE_TRANSLATION_KEY =
  'registration_invalid_zip_code';
export const REGISTRATION_ACCOUNT_ALREADY_EXISTS_FOR_ACCOUNT_NAME_TRANSLATION_KEY =
  'registration_account_already_exists_for_account_name';
export const REGISTRATION_ADDRESS_INVALID_STATE_TRANSLATION_KEY =
  'registration_address_invalid_state';
export const REGISTRATION_MISSING_COUNTRY_CODE_TRANSLATION_KEY =
  'registration_missing_country_code';
export const REGISTRATION_MISSING_BUSINESS_NAME_TRANSLATION_KEY =
  'registration_missing_business_name';
export const REGISTRATION_MISSING_ADDRESS_LINE_ONE_TRANSLATION_KEY =
  'registration_missing_address_line_one';
export const REGISTRATION_MISSING_CITY_TRANSLATION_KEY =
  'registration_missing_city';
export const REGISTRATION_MISSING_ZIP_CODE_TRANSLATION_KEY =
  'registration_missing_zip_code';
export const REGISTRATION_MISSING_PHONE_NUMBER_TRANSLATION_KEY =
  'registration_missing_phone_number';
export const REGISTRATION_MISSING_STATE_TRANSLATION_KEY =
  'registration_missing_state';
export const REGISTRATION_MISSING_WEBSITE_URL_TRANSLATION_KEY =
  'registration_missing_website_url';
export const REGISTRATION_INVALID_STATE_OR_REGION_TRANSLATION_KEY =
  'registration_invalid_state_or_region';
export const REGISTRATION_INVALID_ADDRESS_ERROR_BANNER_MESSAGE_TRANSLATION_KEY =
  'registration_invalid_address';
export const REGISTRATION_INVALID_BUSINESS_NAME_ERROR_BANNER_MESSAGE_TRANSLATION_KEY =
  'registration_business_name_too_long';
export const REGISTRATION_ACCOUNT_EXISTS_ERROR_BANNER_MESSAGE_TRANSLATION_KEY =
  'registration_account_already_exists';
export const REGISTRATION_ACCOUNT_ALREADY_EXISTS_FOR_VENDOR_TRANSLATION_KEY =
  'registration_account_already_exists_for_vendor';
export const REGISTRATION_INVALID_INPUT_ERROR_BANNER_MESSAGE_TRANSLATION_KEY =
  'registration_invalid_input';
export const REGISTRATION_INTERNAL_SERVICE_ERROR_BANNER_MESSAGE_TRANSLATION_KEY =
  'registration_internal_service_error';
export const REGISTRATION_ACCOUNT_LINK_HERE_TEXT =
  'registration_account_link_here';
export const REGISTRATION_INVALID_WEBSITE_URL_TRANSLATION_KEY =
  'registration_invalid_website_url';
export const PARTNER_ACCOUNT_INVALID_FOR_REGISTRATION_HEADER_TRANSLATION_KEY =
  'registration_invalid_partner_account_title';
export const PARTNER_ACCOUNT_INVALID_FOR_REGISTRATION_MESSAGE_TRANSLATION_KEY =
  'registration_invalid_partner_account_message';
export const CONFLICTING_REQUEST_TRANSLATION_KEY = 'conflicting_request';
export const REGISTRATION_DISPLAY_NAME_TOO_LONG_TRANSLATION_KEY =
  'registration_display_name_too_long';
export const REGISTRATION_DISPLAY_NAME_NOT_ALLOWED_TRANSLATION_KEY =
  'registration_display_name_not_allowed';

/**
 * General
 */
export const defaultFormValues = {
  displayName: '',
  business: {
    businessName: '',
    phone: '',
    website: '',
    countryCode: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
  },
};

export const POLLING_INTERVAL = 1000;
export const POLLING_INTERVAL_END = 30_000;
export const SGA_POLLING_INTERVAL_END = 240_000;
export const CREATE_ACCOUNT_FAILED_ALERT_DURATION = 20000;

/**
 * Error message (internal)
 */
export const NO_URL_FOUND_ERROR = 'No URL found!';
export const ACCOUNT_TYPE_MISMATCH_ERROR =
  'Type mismatch detected. Please verify the account status type is correct.';

export const CREATE_ACCOUNT_FAILURE = 'create-account-failed';
export const CREATE_ACCOUNT_ID_MISSING = 'create-account-id-missing';
export const GET_ACCOUNT_STATUS_FAILURE = 'get-account-status-failed';
export const GET_ACCOUNT_STATUS_URL_MISSING = 'get-acount-status-url-missing';
export const GET_ACCOUNT_STATUS_DISABLED = 'get-acount-status-disabled';
export const GET_ACCOUNT_STATUS_TYPE_MISMATCH =
  'get-acount-status-type-mismatch';
export const ACCOUNT_CREATION_STATUS_TIMEOUT = 'create-account-status-timeout';

/**
 * Redirects
 */
export const ACCOUNT_OVERVIEW_REDIRECT_URL = '/am/overview';
export const LEGACY_VENDOR_REGISTRATION_REDIRECT_URL =
  '/advertisingAccounts/create';
